<div mat-dialog-title>
  {{ 'SUPPORT.createTicket' | translate }}
  <div class="spacer"></div>
  <mat-icon class="pointer" mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content>
  <div #errorContainer>
    @if (showErrorMessage) {
    <div class="error-details margin s6 bottom">
      <mat-icon class="icon-error">error_outline</mat-icon>
      <div class="error-message" >
        <div class="mat-body-1">{{ 'SNACKBAR.error' | translate }}</div>
        <div class="mat-body-2">{{getErrorMessage() | translate : {size: formatFileSize(helpDeskConfig.maxAttachmentSize), count: helpDeskConfig.attachmentCount} }}</div>
      </div>
      <div class="spacer"></div>
      <mat-icon class="pointer" (click)="hideErrorElement()">close</mat-icon>
    </div>
    }
  </div>
  <form [formGroup]="supportTicketForm" (keydown.space)="preventLeadingWhiteSpace($event)">
    <mat-form-field aria-required="true">
      <mat-label>{{ 'SUPPORT.title' | translate }}</mat-label>
      <input matInput #title required [maxLength]="helpDeskConfig.maxTitleLength" formControlName="title" (focusout)="preventTrailingWhiteSpace('title')"/>
      <mat-hint align="end">{{ title.value.length }} / {{helpDeskConfig.maxTitleLength}}</mat-hint>
      @if (supportTicketForm.controls['title'].hasError('required')) {
      <mat-error>{{ "SUPPORT.ERROR.required" | translate }}</mat-error>
      }
    </mat-form-field>
    <br />
    <br />
    <mat-form-field class="description" aria-required="true">
      <mat-label>{{ 'SUPPORT.description' | translate }}</mat-label>
      <textarea matInput #description [maxLength]="helpDeskConfig.maxDescriptionLength" rows="4" required formControlName="description" (keydown.enter)="preventLeadingWhiteSpace($event)" (focusout)="preventTrailingWhiteSpace('description')"></textarea>
      <mat-hint align="end" class="textbox-hint">{{ description.value.length }} / {{helpDeskConfig.maxDescriptionLength}}</mat-hint>
      @if (supportTicketForm.controls['description'].hasError('required')) {
      <mat-error class="description-error">{{ "SUPPORT.ERROR.required" | translate }}</mat-error>
      }
    </mat-form-field>
    <br />
    <br />
    <div class="attachment"><span>{{ 'SUPPORT.attachment' | translate }}</span><span class="support-info">{{ 'SUPPORT.supportedFileTypes' | translate}} <mat-icon [matTooltip]="getAllowedExtensions()" matTooltipPosition="before">info_outline</mat-icon></span></div>
    <div class="attachment-warning">
        <span>{{ 'SUPPORT.attachmentWarning' | translate : {count : helpDeskConfig.attachmentCount} }}</span>
    </div>
    <div
      profDragDropFile
      (filesChangeEmiter)="addDragAndDropAttachment($event)"
      class="fileUploadArea"
      [ngClass]="fileExtensionError ? 'errorFileUpload' : 'dashedFileUpload'"
    >
      <mat-icon class="file-upload" [class.error-color]="fileExtensionError">upload_file</mat-icon>
      <p>
      <label>
        <input
          type="file"
          #fileUpload
          style="display: none"
          (click)="fileUpload.value = null"
          (change)="addAttachment($event)"
        />
        <a>{{ 'SUPPORT.clickToUpload' | translate }}</a>
      </label>
       {{ 'SUPPORT.or' | translate }} {{ 'SUPPORT.dragAndDrop' | translate }}</p>
      <p>({{ 'SUPPORT.totalAttachments' | translate : {size: formatFileSize(helpDeskConfig.maxAttachmentSize)} }})</p>
      @if (fileExtensionError) {
      <p class="error-color">{{ 'SUPPORT.ERROR.unsupported-file' | translate }}</p>
      }
    </div>
  </form>
  <div>
    @for (attachment of attachments; track attachment) {
    <div>
      <div class="attachment-uploaded">
        <div><mat-icon class="file-upload">upload_file</mat-icon></div>
        <div>
          <span>{{ attachment.name }}</span>
          <span>{{ formatFileSize(attachment.size) }}</span>
        </div>
        <div>
          <mat-icon class="pointer" (click)="removeAttachment(attachment)">close</mat-icon>
        </div>
      </div>
    </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>{{ 'SUPPORT.cancel' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="!supportTicketForm.valid && !inProgress" (click)="submit()">
    @if (inProgress) {
    <span><mat-spinner diameter="20"></mat-spinner></span>
    }
    @if (!inProgress) {
    <span>{{ 'SUPPORT.submit' | translate }}</span>
    }
  </button>
</mat-dialog-actions>
